var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect } from "react";
export const useAsync = (fn, deps) => {
    const [state, setState] = useState();
    useEffect(() => {
        const resolve = () => __awaiter(this, void 0, void 0, function* () {
            setState({ value: yield fn() });
        });
        resolve();
    }, deps);
    return state;
};
//# sourceMappingURL=use-async.js.map